<template>
  <div id="assignment_change_password" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">Enter password</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">

              <div class="form-group" :class="{ 'has-error': wrongAssigmentChangePassword }">
                <label class="control-label">Enter your password to confirm the deletion of current
                  assignment.</label>
                <input type="password" placeholder="" class="form-control" name="Job Title"
                       v-model="password"
                       v-validate="'required'">
                <span v-show="wrongAssigmentChangePassword" class="help-block">The password you have entered is incorrect</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn green mt-ladda-btn ladda-button js-current-assignment-deletion-confirm-btn"
                  @click.prevent="checkPassword"
                  data-style="expand-left">
            <span class="ladda-label">OK</span>
          </button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {HTTP} from '@/http-common';

export default {
  data() {
    return {
      wrongAssigmentChangePassword: false,
      password: '',
    }
  },
  emits: ['confirmed'],
  methods: {
    checkPassword() {
      let loadingButton = Ladda.create(document.querySelector('.js-current-assignment-deletion-confirm-btn'));
      loadingButton.start();

      HTTP.post('/users/checkpassword', {
        'password': this.password
      }).then((response) => {
        loadingButton.stop();
        if (response.data.status === 'success') {
          this.wrongAssigmentChangePassword = false;
          this.$emit('confirm');
          $('#assignment_change_password').modal('hide');
        } else {
          this.wrongAssigmentChangePassword = true;
        }
      }).catch((error) => {
        loadingButton.stop();
        $('#assignment_change_password').modal('hide');
      });

      return false;
    },
  },
  mounted() {
    $('#assignment_change_password').modal('show').on('hidden.bs.modal', () => {
      this.$emit('hidden', false);
    });
  }
}
</script>



// WEBPACK FOOTER //
// ConfirmAssignmentOverwriteModal.vue?43d79bb2